// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__mWwoD","info":"Note_info__3R_9c","note":"Note_note__1PtKm","actions":"Note_actions__b0_RO"};